<div *ngIf="creator" class="page-container">
  <div class="page-title">Creator Information</div>
  <div class="info-table-container">
    <div class="info-table">
      <div>Name</div>
      <div>{{creator.name}}</div>
      <div>Email</div>
      <div>{{creator.email}}</div>
      <div>Phone</div>
      <div>{{creator.phoneNumber}}</div>
      <div>Agent</div>
      <div>{{creator.primaryAgent}}</div>
      <div>Birth Date</div>
      <div>{{creator.birthDate | date:'MM/dd/yyyy'}}</div>
    </div>
  </div>

  <div class="campaigns-container">
    <div class="table-header-text">Creator Campaigns</div>
    <button class="site-button" (click)="showCreateNewCampaign=true;">Create Campaign</button>
    <div *ngIf="creator.campaigns.length > 0" class="data-table campaigns-table">
      <div class="table-header">ID</div>
      <div class="table-header">Created</div>
      <div class="table-header">Name</div>
      <div class="table-header">Agent</div>
      <div class="table-header">Brand</div>
      <ng-container *ngFor="let campaign of creator.campaigns">
        <div><a [routerLink]="['/campaigns', campaign.id]">{{campaign.id!.substring(0,8)}}</a></div>
        <div>{{campaign.createdDate | date: 'MM/dd/yyyy'}}</div>
        <div>{{campaign.name}}</div>
        <div>{{campaign.agentId}}</div>
        <div>{{getBrandName(campaign.brandId)}}</div>
      </ng-container>
    </div>
    <div *ngIf="creator.campaigns.length === 0">No Campaigns</div>
  </div>


</div>

<!-- <app-dialog [(visible)]="showCreateNewCampaign">
  <div class="dialog-title">Add New Campaign</div>
  <div class="add-resource-form">
    <div class="input-label">Name</div>
    <div><input class="text-input" [(ngModel)]="newCampaign.name" id="name" title="name" type="text" /></div>
    <div class="input-label">Brand</div>
    <div><input class="text-input" [(ngModel)]="newCampaign.brandId" id="brand" title="brand" type="text" /></div>
    <div class="input-label">Agent</div>
    <div><input class="text-input" [(ngModel)]="newCampaign.agentId" id="agent" title="agent" type="text" /></div>
    <div class="input-label">State</div>
    <div>
      <select class="select-input" [(ngModel)]="newCampaign.campaignState" title="state" id="state">
        <option *ngFor="let state of campaignStates" [value]="state.value">{{ state.label }}</option>
      </select>
    </div>
  </div>
  <div class="button-container">
    <button class="site-button" (click)="AddCampaign()">Add Campaign</button>
  </div>
</app-dialog> -->

